export const renderHighlightedText = (text: string, highlightWords: string[] = [], highlightColor: string): string => {
  if (!highlightWords.length) return text

  return highlightWords.reduce(
    (acc, word) => acc.replace(new RegExp(`(${word})`, 'gi'), `<span style="color: ${highlightColor}">$1</span>`),
    text,
  )
}
